<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <p :class="styles">{{ text }}</p>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    text: string;
    classes?: string;
    isUmbraco?: boolean;
    theme: "dark" | "light";
  }>(),
  {}
);
const styles = computed(() => {
  const color =
    props.isUmbraco && props.theme === "dark"
      ? "text-white"
      : props.isUmbraco && props.theme === "light"
      ? "text-aubergine"
      : "text-typography";
  return `${color} ${props.classes}`;
});
</script>
